import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=9efaa7f6&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=9efaa7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efaa7f6",
  null
  
)

export default component.exports